import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class ReminderService {
	constructor(options) {
		this._options = options;
		this._restClient = new RestClient();
		this._rc = new RealtimeClient();
	}

	/**
	 * Get a single reminder by ID
	 * @param {string} reminderId
	 * @param {function} callback
	 */
	getReminderById(reminderId, callback) {
		const url = `/ecosystem/api/reminders/${reminderId}`;
		this._restClient.exec_get(url, callback);
	}

	/**
	 * Get all reminders for the user
	 * @param {function} callback
	 */
	getUserReminders(callback) {
		const url = `/ecosystem/api/reminders`;
		this._restClient.exec_get(url, callback);
	}

	/**
	 * Create a new reminder
	 * @param {object} reminderData
	 * @param {function} callback
	 */
	createReminder(reminderData, callback) {
		const url = `/ecosystem/api/reminders`;
		const body = JSON.stringify(reminderData);
		this._restClient.exec_post(url, body, callback);
	}

	/**
	 * Update a reminder by ID
	 * @param {string} reminderId
	 * @param {object} reminderData
	 * @param {function} callback
	 */
	updateReminder(reminderId, reminderData, callback) {
		const url = `/ecosystem/api/reminders/${reminderId}`;
		const body = JSON.stringify(reminderData);
		this._restClient.exec_put(url, body, callback);
	}

	/**
	 * Delete a reminder by ID
	 * @param {string} reminderId
	 * @param {function} callback
	 */
	deleteReminder(reminderId, callback) {
		const url = `/ecosystem/api/reminders/${reminderId}`;
		this._restClient.exec_delete(url, callback);
	}

	/**
	 * Delete multiple reminders by IDs
	 * @param {Array<string>} reminderIds
	 * @param {function} callback
	 */
	deleteRemindersBulk(reminderIds, callback) {
		const url = `/ecosystem/api/reminders/deleteBulk`;
		const body = JSON.stringify({ reminderIds });
		this._restClient.exec_post(url, body, callback);
	}

	/**
	 * Stream reminders for the user
	 * @param {function} callback
	 */
	streamReminders(callback) {
		const args = {};
		this._rc.subscribe("ecosystem", "/reminders", args, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				callback(null, response);
			}
		});
	}
}
